export const mainCategory = [
  {
    name: "Jewellery Beads",
    categoryId: "jewellery_beads",
    level: 1,
    levelTwoCategory: [

      {
        "parentCategoryId": "jewellery_beads",
        "level": 2,
        "name": "Jewellery Beads",
        "categoryId": "glass_seed_beads"
      }
    ]
  },
  {
    name: "Jewellery Findings",
    categoryId: "jewellery_findings",
    level: 1,
    levelTwoCategory: [

      {
        "parentCategoryId": "jewellery_findings",
        "level": 2,
        "name": "Jewellery Findings",
        "categoryId": "clasps"
      },
      {
        "parentCategoryId": "jewellery_findings",
        "level": 2,
        "name": "Jewellery Findings",
        "categoryId": "jump_ring"
      },
      {
        "parentCategoryId": "jewellery_findings",
        "level": 2,
        "name": "Jewellery Findings",
        "categoryId": "earring_making_parts"
      },
      {
        "parentCategoryId": "jewellery_findings",
        "level": 2,
        "name": "Jewellery Findings",
        "categoryId": "eye_n_head_pins"
      }
    ]
  },
  {
    name: "Tools & Supplies",
    categoryId: "tools_n_supplies",
    level: 1,
  },
  {
    name: "Beading Thread & Wires",
    categoryId: "beading_thread_n_wires",
    level: 1,
    levelTwoCategory: [

      {
        "parentCategoryId": "beading_thread_n_wires",
        "level": 2,
        "name": "Elastic Thread",
        "categoryId": "elastic_thread"
      },
      {
        "parentCategoryId": "beading_thread_n_wires",
        "level": 2,
        "name": "Beading Wire",
        "categoryId": "beading_wire"
      },
      {
        "parentCategoryId": "beading_thread_n_wires",
        "level": 2,
        "name": "Chain",
        "categoryId": "chain"
      }
    ]
  },
  {
    name: "Spiritual Maala",
    categoryId: "spiritual_maala",
    level: 1,
  },
  {
    name: "Packing & Supplies",
    categoryId: "packing_n_supplies",
    level: 1,
  },
];
